import React from 'react'
import AppDialog from 'components/AppDialog'
import { message } from 'antd'
import api, { MetadataAttribute, MetadataEntity } from 'api'
import { AppForm } from 'components/AppFormLayout/AppForm'
import { EntityFieldFormData } from './EntityFieldFormData'
interface Props {
	mode: number
	metadataEntity: MetadataEntity
	afterSave?: (metadataEntity: MetadataEntity) => void
}
// 数据对象-新增字段(也就是修改表)
export default class EntityFieldPage extends React.Component<Props> {
	// 保存
	saveFormData = async () => {
		if (typeof this.appFormRef.current === 'undefined') {
			return
		}
		// 先通过entityId取出数据
		let metadataEntity: MetadataEntity = await api.modeling.entity.getOne(this.props.metadataEntity)
		let metadataAttribute: MetadataAttribute = (this.appFormRef.current as any).getFormData()
		let idsj = -new Date().getTime()
		metadataAttribute.id = idsj
		if (!metadataAttribute) return
		metadataEntity.metadataAttributeList.push(metadataAttribute)
		let res = await api.modeling.entity.updateTable(metadataEntity)
		if (!res) {
			return
		}
		message.success('保存成功！')
		this.props.afterSave && this.props.afterSave(metadataEntity)
		AppDialog.close()
	}
	// 保存并新增
	saveContinueFormData = () => {
		let metadataAttribute: MetadataAttribute = {}
		let idsj = -new Date().getTime()
		metadataAttribute.id = idsj
		if (!metadataAttribute) return
		this.props.afterSave && this.props.afterSave(metadataAttribute)
		AppDialog.close()
	}
	// 关闭
	close = () => {
		AppDialog.close()
	}
	FormActionData = [
		{ title: '保存', id: 'btnSave', type: 'primary', action: this.saveFormData },
		{ title: '取消', id: 'btnCancel', type: 'default', action: this.close },
	]
	appFormRef=React.createRef<unknown>();
	render() {
		let metadataEntity = {} as MetadataAttribute
		return (
			<AppForm
			defaultTabId={0}
			appFormTabList={EntityFieldFormData}
			appFormActionList={this.FormActionData}
			mode={0}
			ref={this.appFormRef}
		></AppForm>
		)
	}
}




// WEBPACK FOOTER //
// ./src/modules/modeling/entity/components/EntityFieldPage.tsx